import { getStorageInfo } from "@/components/common/getStorageInfo";
import { subSystemListItem } from "@/services/UnAuthentService/dto/authenticationResultModel";
import { Toast, ToastShowProps } from "antd-mobile";

/**
 * 轻提示
 * @param p Toast属性
 * @returns 
 */
 export const showTip = (p: ToastShowProps) => {
    return Toast.show({ duration: 3000, ...p })
  }
// 选中子系统编码
export const getSelectSubSystemCode = () => {
    return getStorageInfo('', 'selectSubSystemCode', false)
}
// 所有子系统
export const getAppSystemList = (): subSystemListItem[] => {
    return (getStorageInfo('appSystem') || [])
};
// 选中的子系统
export const getSubSystem = (code: string = getSelectSubSystemCode(), subSystemList = getAppSystemList()): subSystemListItem | undefined => {
    return subSystemList.find((s: subSystemListItem) => s.code === code);
}
